const messages = {
  es: {
    translations: {
      moduleAccess: {
        "title": "Acceso no disponible",
        "planUnavailable": "No disponible en el plan de la empresa.",
        "planRequired": "La empresa necesita un plan válido para acceder a este módulo.",
        "userDenied": "Su usuario no tiene permiso para acceder a este módulo.",
        "globallyUnavailable": "Este módulo no está disponible temporalmente.",
        "loadError": "No se pudo verificar su acceso. Intente nuevamente.",
        "loading": "Verificando disponibilidad...",
        "back": "Volver a conversaciones",
        "retry": "Verificar acceso"
},

      signup: {
        title: "Registrarse",
        toasts: {
          success: "?Usuario creado con ?xito! ?Inicia sesi?n!.",
          fail: "Error al crear el usuario. Comprueba los datos introducidos."
        },
        form: {
          name: "Nombre",
          email: "Correo electr?nico",
          password: "Contrasena",
          company: "Nombre de la Organizaci?n",
          phone: "Whatsapp (C?digo de ?rea + N?MERO)"
        },
        buttons: {
          submit: "Registrarse",
          login: "?Ya tienes una cuenta? ?Inicia sesi?n!"
        }
      },
      login: {
        title: "Iniciar Sesi?n",
        form: {
          email: "Correo electr?nico",
          password: "Contrasena",
          button: "Acceder"
        },
        buttons: {
          submit: "Iniciar Sesi?n",
          register: "?No tienes una cuenta? ?Reg?strate!"
        }
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "?Empresa creada con ?xito!"
        }
      },
      auth: {
        toasts: {
          success: "?Inicio de sesi?n realizado con ?xito!"
        },
        dueDate: {
          expiration: "Tu suscripci?n vence en",
          days: "?d?as!",
          day: "?d?a!",
          expirationToday: "?Tu suscripci?n vence hoy!"
        },
        token: "Token"
      },
      dashboard: {
        title: "Panel de Control",
        buttons: {
          filter: "Filtrar"
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Agentes",
          performance: "Rendimiento"
        },
        charts: {
          performance: "Gr?ficos",
          userPerformance: "Gr?fico de Usuarios",
          perDay: {
            title: "Atendimientos hoy: "
          }
        },
        cards: {
          inAttendance: "En Atenci?n",
          waiting: "En Espera",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Mensajes Recibidos",
          totalSentMessages: "Mensajes Enviados",
          averageServiceTime: "T.M. de Atenci?n",
          averageWaitingTime: "T.M. de Espera",
          status: "Estado (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos"
        },
        users: {
          name: "Nombre",
          numberAppointments: "Cantidad de Atendimientos",
          statusNow: "Actual",
          totalCallsUser: "Total de atendimientos por usuario",
          totalAttendances: "Total de atendimientos",
          totalLabel: "Total de atendimientos: {{count}}",
          queues: "Colas",
          defaultQueue: "Conexi?n Predeterminada",
          workingHours: "Horario Laboral",
          startWork: "Inicio de Trabajo",
          endWork: "Fin de Trabajo",
          farewellMessage: "Mensaje de Despedida",
          theme: "Tema Predeterminado",
          menu: "Men? Predeterminado",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final"
        },
        licence: {
          available: "Disponible hasta"
        },
        assessments: {
          totalCalls: "Total de Atendimientos",
          callsWaitRating: "Atendimientos esperando evaluaci?n",
          callsWithoutRating: "Atendimientos sin evaluaci?n",
          ratedCalls: "Atendimientos evaluados",
          evaluationIndex: "?ndice de evaluaci?n",
          score: "Puntuaci?n",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detractores"
        }
      },
      reports: {
        title: "Informe de Encuestas Realizadas",
        operator: "Operador",
        period: "Per?odo",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Informes",
        calls: "Atendimientos",
        search: "Encuestas",
        durationCalls: "Duraci?n de los Atendimientos",
        grupoSessions: "Atendimientos en Grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Generando informe comprimido, por favor espere.",
          errorToast: "Error al generar el informe",
          back: "Volver",
          groupServiceReport: "Informe de Atendimientos en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha de ?ltima Actualizaci?n",
          agent: "Qui?n Atendi?",
          agentClosed: "Qui?n Cerr?",
          waitingAssistance: "Esperando Atenci?n",
          process: "En Atenci?n"
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidad",
          percentage: "porcentaje",
          title: "Informe de Encuestas Realizadas",
          activeSearch: "Encuesta activa",
          inactiveSearch: "Encuesta inactiva"
        },
        ticketDurationDetail: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Duraci?n del Atendimiento",
          startService: "Inicio del Atendimiento",
          lastUpdated: "?ltima Actualizaci?n",
          lastAgent: "?ltimo Agente",
          durationFinished: "Duraci?n despu?s de finalizado"
        },
        ticketDuration: {
          title: "Informe de Duraci?n de los Atendimientos",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duraci?n de los finalizados",
          durationAfterFinished: "Duraci?n despu?s de finalizado",
          actions: "Acciones"
        },
        ticketReports: {
          msgToast: "Generando informe comprimido, por favor espere.",
          title: "Informe de Atendimientos"
        },
        pdf: {
          title: "Relaci?n de Atendimientos Realizados",
          exportTitle: "Relaci?n de Atendimientos en Grupos Realizados"
        }
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas"
      },
      contactImportWpModal: {
        title: "Exportar Contactos para el Excel",
        buttons: {
          downloadModel: "Descargar modelo de excel para importaci?n",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar Contactos"
        }
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espera... ?Tus conexiones se reiniciar?n!",
        newConnection: "Nueva Conexi?n",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar Soporte",
        toasts: {
          deleted: "?Conexi?n eliminada con ?xito!",
          closedimported: "Estamos cerrando los tickets importados, por favor espere unos instantes"
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage: "Si confirmas, todos los tickets importados ser?n cerrados",
          deleteTitle: "Eliminar",
          deleteMessage: "?Est?s seguro? Esta acci?n no se puede revertir.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "?Est?s seguro? Deber?s leer el c?digo QR de nuevo."
        },
        buttons: {
          add: "Agregar Conexi?n",
          disconnect: "Desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "CODIGO QR",
          newQr: "Nuevo CODIGO QR",
          closedImported: "Cerrar todos los tickets importados",
          preparing: "Preparando mensajes para importaci?n",
          importing: "Importando Mensajes de WhatsApp",
          newQr: "Nuevo CODIGO QR",
          processed: "Procesado",
          in: "de",
          connecting: "Conectando"
        },
        typography: {
          processed: "Procesado",
          in: "de",
          date: "Fecha del mensaje"
        },
        toolTips: {
          disconnected: {
            title: "Error al iniciar sesi?n de WhatsApp",
            content: "Aseg?rate de que tu celular est? conectado a internet y intenta de nuevo, o solicita un nuevo C?digo QR"
          },
          qrcode: {
            title: "Esperando lectura del C?digo QR",
            content: "Haz clic en el boton 'CODIGO QR' y lee el codigo QR con tu celular para iniciar la sesion"
          },
          connected: {
            title: "?Conexi?n establecida!"
          },
          timeout: {
            title: "La conexi?n con el celular fue perdida",
            content: "Aseg?rate de que tu celular est? conectado a internet y el WhatsApp est? abierto, o haz clic en el bot?n 'Desconectar' para obtener un nuevo C?digo QR"
          }
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "?ltima actualizaci?n",
          "default": "Predeterminado",
          actions: "Acciones",
          session: "Sesi?n",
          number: "N?mero de Whatsapp"
        }
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimiento Existente"
        },
        form: {
          message: "Este contacto ya est? en atendimiento:",
          user: "Agente",
          queue: "Cola",
          messageWait: "Este contacto ya esta esperando atendimiento. Ve en la pestana Esperando!"
        }
      },
      showTicketLogModal: {
        title: {
          header: "Registros"
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Cola definida.",
          open: " inici? el atendimiento.",
          access: "accedi? al ticket.",
          transfered: "transfiri? el ticket.",
          receivedTransfer: "recibi? el ticket transferido.",
          pending: "devolvi? la cola.",
          closed: "cerr? el ticket",
          reopen: "reabri? el ticket",
          redirect: "- redirigido"
        }
      },
      whatsappModal: {
        title: {
          add: "Agregar Conexi?n",
          edit: "Editar Conexi?n"
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "NPS",
          integrations: "Integraciones",
          schedules: "Horario de atenci?n"
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del dispositivo",
          importOldMessages: "Fecha de inicio de la importaci?n",
          importRecentMessages: "Fecha de finalizaci?n de la importaci?n",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets despu?s de la importaci?n",
          name: "Nombre",
          queueRedirection: "Redirecci?n de Cola",
          queueRedirectionDesc: "Selecciona una cola para que los contactos que no tienen cola sean redirigidos",
          "default": "Predeterminado",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redirigir a la cola",
          importAlert: "ATENCI?N: Al guardar, tu conexi?n se cerrar?, ser? necesario leer de nuevo el C?digo QR para importar los mensajes",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Crear nuevo ticket en x minutos",
          maxUseBotQueues: "Enviar bot x veces",
          timeUseBotQueues: "Enviar bot en x minutos",
          expiresTicket: "Cerrar chats abiertos despu?s de x minutos",
          expiresTicketNPS: "Cerrar chats esperando evaluaci?n despu?s de x minutos",
          maxUseBotQueuesNPS: "Cantidad m?xima de veces que la evaluaci?n va a ser enviada",
          closeLastMessageOptions1: "Del agente/Cliente",
          closeLastMessageOptions2: "Del agente",
          outOfHoursMessage: "Mensaje de fuera de horario de atenci?n",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusi?n",
          lgpdLinkPrivacy: "Link para pol?tica de privacidad",
          lgpdMessage: "Mensaje de bienvenida LGPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrado por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmaci?n del contacto",
          ratingMessage: "Mensaje de evaluaci?n - La escala debe ser de 0 a 10",
          token: "Token para integraci?n externa",
          sendIdQueue: "Cola",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage: "Tiempo en minutos para env?o del aviso de inactividad",
          whenExpiresTicket: "Cerrar chats abiertos cuando la ?ltima mensaje sea",
          expiresInactiveMessage: "Mensaje de cierre por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Cola para importar los mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Deshabilitado",
          minutes: "minutos"
        },
        success: "Conexi?n guardada con ?xito.",
        errorSendQueue: "Se inform? tiempo para redirigir cola, pero no se seleccion? fila para redirigir. Ambos campos deben estar llenos",
        errorExpiresNPS: "Es obligatorio informar un tiempo para evaluaci?n cuando se utiliza el NPS.",
        errorRatingMessage: "Es obligatorio informar un mensaje de evaluaci?n cuando se utiliza el NPS."
      },
      qrCode: {
        message: "Lee el QrCode para iniciar la sesi?n"
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "?Contacto eliminado con ?xito!"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar ",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage: "?Est?s seguro de que deseas eliminar este contacto? Todos los atendimientos relacionados se perder?n.",
          blockContact: "?Est?s seguro de que deseas bloquear este contacto?",
          unblockContact: "?Est?s seguro de que deseas desbloquear este contacto?",
          importMessage: "?Desea importar todos los contactos del tel?fono?",
          importChat: "Importar Conversaciones",
          wantImport: "?Desea importar todas las conversaciones del tel?fono?"
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto"
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexi?n",
          email: "Correo electr?nico",
          actions: "Acciones",
          lastMessage: "?ltima Mensaje"
        },
        menu: {
          importYourPhone: "Importar del dispositivo predeterminado",
          importToExcel: "Importar / Exportar del Excel"
        }
      },
      forwardMessage: {
        text: "Reenviada"
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar"
        }
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "M?ximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "M?ximo de mensajes en el Historial",
          voiceKey: "Clave de la API de Voz",
          voiceRegion: "Regi?n de Voz"
        },
        success: "?Prompt guardado con ?xito!",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Cola",
          max_tokens: "M?ximo Tokens Respuesta",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "?Est?s seguro? ?Esta acci?n no se puede revertir!"
        },
        buttons: {
          add: "Agregar Prompt"
        }
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto"
        },
        form: {
          mainInfo: "Datos del contacto",
          extraInfo: "Informaci?n adicional",
          name: "Nombre",
          number: "N?mero de Whatsapp",
          email: "Correo electr?nico",
          walletUsers: "Cartera",
          walletUsersPlaceholder: "Selecciona los usuarios de la cartera",
          walletUsersHelp:
            "Sin cartera el contacto queda p?blico. Con cartera, solo los usuarios vinculados podr?n acceder.",
          extraName: "Nombre del campo",
          extraValue: "Valor",
          chatBotContact: "Deshabilitar chatbot",
          termsLGDP: "T?rminos LGPD aceptados en:",
          whatsapp: "Conexi?n Origen: "
        },
        buttons: {
          addExtraInfo: "Agregar informaci?n",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Contacto guardado con ?xito."
        },
       flowbuilder: {
        title: "Flowbuilder",
        subMenus: {
          campaign: "Flujo de Campana",
          conversation: "Flujo de Conversaci?n"
        } 
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Flujo predeterminado"
      },
      queueModal: {
        title: {
          queueData: "Datos de la cola",
          text: "Horarios de atenci?n",
          add: "Agregar cola",
          edit: "Editar cola",
          confirmationDelete: "Tem certeza? Todas as op??es de integra??es ser?o deletadas."
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la cola (Bot)",
          rotate: "Rotaci?n",
          timeRotate: "Tiempo de Rotaci?n",
          greetingMessage: "Mensaje de bienvenida",
          complationMessage: "Mensaje de conclusi?n",
          outOfHoursMessage: "Mensaje de fuera de horario de atenci?n",
          token: "Token",
          integrationId: "Integraci?n",
          fileListId: "Lista de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de men?",
          message: "Mensaje de retorno",
          queue: "Cola para transferencia",
          integration: "Integraci?n",
          file: "Archivo"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue opciones para construir un chatbot",
          toolTip: "Si hay solo una opci?n, se elegir? autom?ticamente, haciendo que el bot responda con el mensaje de la opci?n y siga adelante",
          selectOption: "Seleccione una opci?n",
          text: "Texto",
          attendent: "Agente",
          queue: "Cola",
          integration: "Integraci?n",
          file: "Archivo",
          toolTipMessageTitle: "El mensaje es obligatorio para seguir al siguiente nivel",
          toolTipMessageContent: "El mensaje es obligatorio para seguir al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Cola",
          selectIntegration: "Seleccione una Integraci?n",
          addOptions: "Agregar opciones"
        },
        serviceHours: {
          dayWeek: "D?a de la semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Mi?rcoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "S?bado",
          sunday: "Domingo"
        }
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto"
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "Contenido Json",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversaci?n",
          typebotKeywordFinish: "Palabra para finalizar el ticket",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversaci?n",
          typebotUnknownMessage: "Mensaje de opci?n inv?lida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot"
        },
        messages: {
          testSuccess: "?Integraci?n probada con ?xito!",
          addSuccess: "Integraci?n agregada con ?xito.",
          editSuccess: "Integraci?n editada con ?xito."
        }
      },
      userModal: {
        warning: "?Para hacer la importaci?n de los mensajes es necesario leer el qrCode nuevamente !!!",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar imagen",
          removeImage: "Eliminar imagen"
        },
        form: {
          name: "Nombre",
          none: "Ninguna",
          email: "Correo electr?nico",
          password: "Contrasena",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          whatsapp: "Conexi?n Predeterminada",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Deshabilitado",
          allTicket: "Visualizar llamadas sin cola",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Men? predeterminado",
          defaultTheme: "Tema Predeterminado",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversaciones de otras colas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Deshabilitado",
          allUserChat: "Ver conversaciones de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel de Atendimientos",
          allowConnections: "Permitir acciones en las conexiones",
          allowKanban: "Acceder al Kanban operativo",
          allowCrm: "Acceder al CRM comercial"
        },
        tabs: {
          general: "General",
          permissions: "Permisos"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen"
        },
        success: "Usuario guardado con ?xito."
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa"
        },
        form: {
          name: "Nombre",
          email: "Correo electr?nico",
          passwordDefault: "Contrasena",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Empresa guardada con ?xito."
      },
      scheduleModal: {
        title: {
          add: "Nueva Programaci?n",
          edit: "Editar Programaci?n"
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de Programaci?n",
          sentAt: "Fecha de Env?o",
          assinar: "Enviar Firma"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addSchedule: "Agregar programaci?n"
        },
        success: "Programaci?n guardada con ?xito."
      },
      tagModal: {
        title: {
          add: "Nueva Etiqueta",
          edit: "Editar Etiqueta",
          addKanban: "Nueva Columna",
          editKanban: "Editar Columna"
        },
        form: {
          name: "Nombre",
          color: "Color",
          kanbanOrder: "Orden de la columna",
          timeLane: "Tiempo en horas para redirigir a la columna",
          nextLaneId: "Columna",
          greetingMessageLane: "Mensaje de bienvenida de la columna",
          rollbackLaneId: "Volver a la Columna despu?s de retomar el atendimiento"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Etiqueta guardada con ?xito.",
        successKanban: "Columna guardada con ?xito."
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos"
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo"
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opci?n"
        },
        success: "?Lista de archivos guardada con ?xito!"
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para comenzar a conversar."
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: " ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO ABAJO ",
          titleFileList: "Lista de archivo(s)"
        }
      },
      chatInternal: {
        new: "Nueva",
        modal: {
          conversation: "Conversaci?n",
          title: "T?tulo",
          filterUsers: "Filtrar por Usuarios",
          cancel: "Cerrar",
          save: "Guardar"
        },
        modalDelete: {
          title: "Eliminar Conversaci?n",
          message: "Esta acci?n no se puede revertir, ?confirmar?"
        }
      },
      ticketsManager: {
        questionCloseTicket: "?DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "S?",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo"
        }
      },
      ticketsQueueSelect: {
        placeholder: "Colas"
      },
      tickets: {
        inbox: {
          closedAllTickets: "?Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "S?",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos"
        },
        toasts: {
          deleted: "El atendimiento que estabas fue eliminado."
        },
        notification: {
          message: "Mensaje de"
        },
        tabs: {
          open: {
            title: "Abiertas"
          },
          closed: {
            title: "Resueltos"
          },
          search: {
            title: "B?squeda"
          }
        },
        search: {
          placeholder: "Buscar atendimiento y mensajes",
          filterConections: "Filtrar por Conexi?n",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente"
          },
          filterUsers: "Filtrar por Usuarios",
          filterContacts: "Filtrar por Contactos",
          ticketsPerPage: "Tickets por p?gina"
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a la Cola",
          scredule: "Programaci?n",
          deleteTicket: "Eliminar Ticket"
        },
        closedTicket: {
          closedMessage: "Cerrar Ticket Con Mensaje de Despedida",
          closedNotMessage: "Cerrar Ticket Sin Mensaje de Despedida"
        }
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a cola",
        fieldQueuePlaceholder: "Selecciona una cola",
        fieldWhatsapp: "Selecciona un whatsapp",
        noOptions: "Ning?n usuario encontrado con ese nombre",
        msgTransfer: "Observaciones - mensaje interno, no va para el cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar"
        }
      },
      ticketsList: {
        called: "Llamado",
        today: "Hoy",
        missedCall: "Llamada de voz/video perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Atendiendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "?Nada aqu?!",
        noTicketsMessage: "Ning?n atendimiento encontrado con este estado o t?rmino buscado",
        noQueue: "Sin Cola",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opciones de Kanban"
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar sector"
        }
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        kanbanStageLabel: "Etapa Kanban",
        kanbanStagePlaceholder: "Seleccione una etapa Kanban",
        noKanbanStage: "Sin etapa Kanban",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar"
        }
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Escribe para buscar el contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar"
        }
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel",
          tickets: "Atendimientos",
          quickMessages: "Respuestas r?pidas",
          contacts: "Contactos",
          queues: "Colas & Chatbot",
          flowbuilder: "Flowbuilder",
          tags: "Etiquetas",
          administration: "Administraci?n",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuraciones",
          files: "Lista de archivos",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programaciones",
          campaigns: "Campanas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versi?n",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          knowledgeBases: "Bases de conocimiento",
          aiUsage: "Consumo de IA",
          allConnections: "Administrar conexiones",
          reports: "Informes",
          management: "Gerencia"
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Salir",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y dar? continuidad en tu atendimiento.",
            virtualAssistant: "Asistente Virtual",
            token: "Token inv?lido, por favor entra en contacto con el administrador de la plataforma."
          },
          message: {
            location: "Ubicaci?n",
            contact: "Contacto"
          },
          notRegister: "Ning?n registro",
          refresh: "Actualizar"
        }
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Portugu?s",
        es: "Espanol",
        en: "English",
        tr: "T?rk?e"
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "N?mero",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID del usuario/agente",
          queueId: "ID de la Cola"
        },
        mediaMessage: {
          number: "N?mero",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado"
        },
        API: {
          title: "Documentaci?n para env?o de mensajes",
          methods: {
            title: "M?todos de Env?o",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Media"
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1: "Antes de enviar mensajes, es necesario el registro del token vinculado a la conexi?n que enviar? los mensajes. <br />Para realizar el registro acceda al men? 'Conexiones', haga clic en el bot?n editar de la conexi?n e inserte el token en el debido campo.",
            comments2: "El n?mero para env?o no debe tener m?scara o caracteres especiales y debe ser compuesto por:",
            codeCountry: "C?digo del Pa?s",
            code: "DDD",
            number: "N?mero"
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions: "Siguen abajo la lista de informaciones necesarias para env?o de los mensajes de texto:"
          },
          media: {
            title: "2. Mensajes de Media",
            instructions: "Siguen abajo la lista de informaciones necesarias para env?o de los mensajes de texto:"
          }
        }
      },
      notifications: {
        noTickets: "Ninguna notificaci?n."
      },
      quickMessages: {
        title: "Respuestas R?pidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin anexo",
        confirmationModal: {
          deleteTitle: "Exclusi?n",
          deleteMessage: "?Esta acci?n es irreversible! ?Desea proseguir?"
        },
        buttons: {
          add: "Agregar",
          attach: "Anexar Archivo",
          cancel: "Cancelar",
          edit: "Editar"
        },
        toasts: {
          success: "?Atajo agregado con ?xito!",
          deleted: "?Atajo removido con ?xito!"
        },
        dialog: {
          title: "Mensaje R?pida",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visi?n"
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Estado"
        }
      },
      contactLists: {
        title: "Listas de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Lista"
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta accion no se puede revertir."
        },
        toasts: {
          deleted: "Registro excluido"
        }
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "B?squeda",
        buttons: {
          add: "Nuevo",
          lists: "Listas",
          import: "Importar"
        },
        dialog: {
          name: "Nombre",
          number: "N?mero",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar"
        },
        table: {
          name: "Nombre",
          number: "N?mero",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Acciones"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acci?n no se puede revertir.",
          importMessage: "?Desea importar los contactos de esta planilla? ",
          importTitlte: "Importar"
        },
        toasts: {
          deleted: "Registro excluido"
        }
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "B?squeda",
        subMenus: {
          list: "Panel",
          tags: "Lanes"
        }
      },
      campaigns: {
        title: "Campanas",
        searchPlaceholder: "B?squeda",
        subMenus: {
          list: "Listado",
          listContacts: "Lista de contactos",
          settings: "Configuraciones"
        },
        settings: {
          randomInterval: "Intervalo Aleatorio de Disparo",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor despu?s de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de disparo mayor",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido"
        },
        buttons: {
          add: "Nueva Campana",
          contactLists: "Listas de Contactos"
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexi?n",
          contactList: "Lista de Contactos",
          option: "Ninguna",
          disabled: "Deshabilitada",
          enabled: "Habilitada",
          status: "Estado",
          scheduledAt: "Programaci?n",
          completedAt: "Conclu?da",
          confirmation: "Confirmaci?n",
          actions: "Acciones"
        },
        dialog: {
          new: "Nueva Campana",
          update: "Editar Campana",
          readonly: "Apenas Visualizaci?n",
          help: "Utiliza variables como {nome}, {numero}, {email} o define variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmaci?n 1",
            confirmationMessage2: "Mensaje de Confirmaci?n 2",
            confirmationMessage3: "Mensaje de Confirmaci?n 3",
            confirmationMessage4: "Mensaje de Confirmaci?n 4",
            confirmationMessage5: "Mensaje de Confirmaci?n 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexi?n",
            status: "Estado",
            scheduledAt: "Programaci?n",
            confirmation: "Confirmaci?n",
            contactList: "Lista de Contacto",
            tagList: "Etiquetas",
            statusTicket: "Estado del Ticket",
            openTicketStatus: "Abierto",
            pendingTicketStatus: "Pendiente",
            closedTicketStatus: "Cerrado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Deshabilitado",
            openTicket: "Abrir ticket"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Cerrar",
            attach: "Anexar Archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acci?n no se puede revertir."
        },
        toasts: {
          success: "Operaci?n realizada con ?xito",
          cancel: "Campana cancelada",
          restart: "Campana reiniciada",
          deleted: "Registro excluido"
        }
      },
      campaignReport: {
        title: "Informe de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campana",
        validContacts: "Contactos V?lidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregues",
        connection: "Conexi?n",
        contactLists: "Lista de Contactos",
        schedule: "Programaci?n",
        conclusion: "Conclusi?n"
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "B?squeda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos"
        },
        table: {
          priority: "Prioridad",
          title: "T?tulo",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones"
        },
        dialog: {
          edit: "Edici?n de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualizaci?n",
          form: {
            priority: "Prioridad",
            title: "T?tulo",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo"
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo"
          }
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acci?n no se puede revertir."
        },
        toasts: {
          success: "Operaci?n realizada con ?xito",
          deleted: "Registro excluido"
        }
      },
      campaignsConfig: {
        title: "Configuraciones de Campanas"
      },
      queues: {
        title: "Colas & Chatbot",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de bienvenida",
          orderQueue: "Ordenaci?n de la cola (bot)",
          actions: "Acciones",
          ID: "ID"
        },
        buttons: {
          add: "Agregar cola"
        },
        toasts: {
          success: "Cola guardada con ?xito",
          deleted: "Cola excluida con ?xito"
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Voc? tem certeza? Essa a??o n?o pode ser revertida! Os atendimentos dessa fila continuar?o existindo, mas n?o ter?o mais nenhuma fila atribu?da."
        }
      },
      queue: {
        queueData: "Datos"
      },
      queueSelect: {
  inputLabel: "Colas",
  inputLabelRO: "Colas de solo lectura",
  withoutQueue: "Sin cola",
  undefined: "Cola no encontrada",
      },
      reports: {
        title: "Informes de Atendimientos",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha Apertura",
          dateClose: "Fecha Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexi?n",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "?lt. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atendimiento"
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Apenas Evaluados"
        },
        searchPlaceholder: "Buscar..."
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "?ltima actualizaci?n",
          actions: "Acciones"
        },
        buttons: {
          add: "Agregar Proyecto"
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Voc? tem certeza? Essa a??o n?o pode ser revertida! e ser? removida das filas e conex?es vinculadas"
        }
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Estado",
          name: "Nombre",
          email: "Correo electr?nico",
          profile: "Perfil",
          startWork: "Inicio de trabajo",
          endWork: "Fin de trabajo",
          actions: "Acciones",
          ID: "ID"
        },
        buttons: {
          add: "Agregar usuario"
        },
        toasts: {
          deleted: "Usuario excluido con ?xito."
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Todos los datos del usuario se perder?n. Los atendimientos abiertos de este usuario se mover?n para la cola."
        }
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo electr?nico",
          password: "Contrasena",
          phone: "Tel?fono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Atendentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre Plan",
          numberQueues: "Filas",
          useCampaigns: "Campanas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Creada En",
          dueDate: "Vencimiento",
          lastLogin: "?lt. Login",
          actions: "Acciones",
          money: "?",
          yes: "S?",
          no: "No",
          document: "CNPJ/CPF",
          recurrence: "Recurrencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Excluir",
          user: "Usuario",
          save: "Guardar"
        },
        buttons: {
          add: "Agregar empresa"
        },
        toasts: {
          deleted: "Empresa excluida con ?xito."
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Todos los datos de la empresa se perder?n. Los tickets abiertos de este usuario se mover?n para la cola."
        }
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campanas",
          schedules: "Programaciones",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Guardar",
          yes: "S?",
          no: "No",
          money: "?",
          public: "P?blico"
        }
      },
      helps: {
        title: "Central de Ayuda",
        settings: {
          codeVideo: "C?digo del Video",
          description: "Descripci?n",
          clear: "Limpiar",
          delete: "Excluir",
          save: "Guardar"
        }
      },
      schedules: {
        title: "Programaciones",
        confirmationModal: {
          deleteTitle: "?Est?s seguro de que quieres excluir este Agendamento?",
          deleteMessage: "Esta acci?n no se puede revertir."
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de Programaci?n",
          sentAt: "Fecha de Env?o",
          status: "Estado",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Programaci?n"
        },
        toasts: {
          deleted: "Programaci?n excluida con ?xito."
        }
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "?Est?s seguro de que quieres excluir esta Tag?",
          deleteMessage: "Esta acci?n no se puede revertir."
        },
        table: {
          id: "ID",
          name: "Nombre",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva Tag"
        },
        toasts: {
          deleted: "Tag excluido con ?xito."
        }
      },
      tagsKanban: {
        title: "Columnas Kanban",
        laneDefault: "En abierto",
        confirmationModal: {
          deleteTitle: "Estas seguro de que quieres excluir esta columna?",
          deleteMessage: "Esta acci?n no se puede revertir."
        },
        table: {
          name: "Nombre",
          color: "Color",
          order: "Orden",
          tickets: "Tickets",
          actions: "Acciones"
        },
        buttons: {
          add: "Nueva columna"
        },
        toasts: {
          deleted: "Columna excluida con exito."
        }
      },
      files: {
        title: "Lista de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acci?n"
        },
        toasts: {
          deleted: "?Lista excluida con ?xito!",
          deletedAll: "?Todas las listas fueron excluidas con ?xito!"
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Eliminar Todos"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteAllTitle: "Eliminar Todos",
          deleteMessage: "?Est?s seguro de que deseas eliminar esta lista?",
          deleteAllMessage: "?Est?s seguro de que deseas eliminar todas las listas?"
        }
      },
      settings: {
        success: "Configuraciones guardadas con ?xito.",
        title: "Configuraciones",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          superConnections: "Conexiones Globales"
        },
        settings: {
          userCreation: {
            name: "Crea??o de usu?rio",
            options: {
              enabled: "Activado",
              disabled: "Desactivado"
            }
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda"
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creaci?n de Company/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamiento por Cola",
            companyManagement: "Gerenciamiento por Empresa",
            connectionManagement: "Gerenciamiento por Conexi?n",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket: "Enviar mensaje transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo del Bot",
            userRandom: "Escolher atendente aleat?rio",
            buttons: "Botones",
            acceptCallWhatsapp: "Informar que no acepta llamadas en whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues: "Enviar saludo cuando haya solamente 1 fila",
            sendQueuePosition: "Enviar mensaje con la posici?n de la cola",
            sendFarewellWaitingTicket: "Enviar mensaje de despedida en el Aguardando",
            acceptAudioMessageContact: "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamiento LGPD",
            requiredTag: "Tag obligatoria para cerrar ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir para otra cola",
            DirectTicketsToWallets: "Mover autom?ticamente cliente para cartera",
            showNotificationPending: "Mostrar notificaci?n para tickets pendientes"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posici?n en la cola",
            AcceptCallWhatsappMessage: "Mensaje para informar que no acepta llamadas",
            greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
            transferMessage: "Mensaje de transferencia - ${queue.name} = fila destino"
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de bienvenida(LGPD)",
            linkLGPD: "Link de la pol?tica de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje apagada",
            alwaysConsent: "Siempre solicitar consentimiento",
            obfuscatePhoneUser: "Ofuscar n?mero tel?fono para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado"
          }
        }
      },
      messagesList: {
        header: {
          assignedTo: "Atribu?do a:",
          dialogRatingTitle: "?Desea dejar una evaluaci?n de atendimiento para el cliente?",
          dialogClosingTitle: "?Finalizando el atendimiento con el cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Evaluaci?n",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elige un men? de evaluaci?n",
          notMessage: "Ning?n mensaje seleccionado",
          amount: "Valor de prospec??o",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluaci?n",
            enableIntegration: "Habilitar integraci?n",
            disableIntegration: "Deshabilitar integraci?n",
            logTicket: "Logs del Ticket",
            requiredTag: "Debes asignar una etiqueta antes de cerrar el ticket."
          }
        }
      },
      messagesInput: {
        placeholderPrivateMessage: "Escribe un mensaje o aprieta / para respuestas r?pidas",
        placeholderOpen: "Escribe un mensaje o aprieta / para respuestas r?pidas",
        placeholderClosed: "Reabra o acepte este ticket para enviar un mensaje.",
        signMessage: "Assinar",
        privateMessage: "Mensaje Privado"
      },
      contactDrawer: {
        header: "Datos del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear"
        },
        extraInfo: "Otras informaciones",
        wallet: {
          title: "Cartera",
          public: "Sin cartera",
          restricted: "Restringido",
          publicDescription: "Contacto visible para toda la empresa.",
          assignToMe: "Asociar cartera",
          assigning: "Asociando..."
        }
      },
      messageVariablesPicker: {
        label: "Variav?is disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludo",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "N? de Llamada",
          queue: "Sector",
          connection: "Conexi?n"
        }
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Finalizar sin despedida",
        acceptAudioMessage: "?Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Ticket",
          textarea: "Observaci?n",
          placeholder: "Inserta aqu? la informaci?n que deseas registrar"
        },
        confirmationModal: {
          title: "Deletar el ticket del contacto",
          titleFrom: "del contacto ",
          message: "?Atenci?n! Todas las mensagens relacionadas con el ticket se perder?n."
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar"
        }
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar"
        }
      },
      messageInput: {
        tooltip: {
          signature: "Habilitar/Deshabilitar Firma",
          privateMessage: "Habilitar/Deshabilitar Mensaje Privada",
          meet: "Enviar link para videoconferencia"
        },
        type: {
          imageVideo: "Fotos y v?deos",
          cam: "C?mara",
          contact: "Contacto",
          meet: "V?deo llamada"
        }
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "Editar",
        forward: "Reenviar",
        toForward: "Reenviar",
        talkTo: "Hablar con",
        react: "Reaccionar",
        transcribeAudio: "Transcribir audio",
        close: "Cerrar",
        confirmationModal: {
          title: "?Borrar mensaje?",
          message: "Esta acci?n no se puede deshacer.",
        },
      },
      invoices: {
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Colas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acci?n"
        }
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe haber al menos un WhatsApp predeterminado.",
        ERR_NO_DEF_WAPP_FOUND: "Ning?n WhatsApp predeterminado encontrado. Verifique la p?gina de conexiones.",
        ERR_WAPP_NOT_INITIALIZED: "Esta sesi?n de WhatsApp no fue inicializada. Verifique la p?gina de conexiones.",
        ERR_WAPP_CHECK_CONTACT: "No fue posible verificar el contacto de WhatsApp. Verifique la p?gina de conexiones",
        ERR_WAPP_INVALID_CONTACT: "Este no es un n?mero de Whatsapp v?lido.",
        ERR_WAPP_DOWNLOAD_MEDIA: "No fue posible descargar medios de WhatsApp. Verifique la p?gina de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticaci?n. Por favor, intente nuevamente.",
        ERR_SENDING_WAPP_MSG: "Error al enviar mensaje de WhatsApp. Verifique la p?gina de conexiones.",
        ERR_DELETE_WAPP_MSG: "No fue posible eliminar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya existe un t?quete abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesi?n expirada. Por favor, inicie sesi?n.",
        ERR_USER_CREATION_DISABLED: "La creaci?n de usuario fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tiene permiso para acceder a este recurso.",
        ERR_USER_FEATURE_PERMISSION_DENIED:
          "Su usuario no tiene acceso a esta función.",
        ERR_INVALID_KANBAN_LANE: "Columna kanban invalida.",
        ERR_KANBAN_LANE_CANNOT_REFERENCE_SELF:
          "La columna no puede apuntar a si misma.",
        ERR_INVALID_KANBAN_STAGE: "Etapa kanban invalida.",
        ERR_TICKET_KANBAN_STAGE_CONFLICT:
          "Este ticket fue movido al mismo tiempo. Actualice el tablero e intente nuevamente.",
        ERR_KANBAN_TAG_HAS_TICKET_STAGE_CONFLICTS:
          "Esta etiqueta no puede convertirse en columna porque generaria conflictos en tickets existentes.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este n?mero.",
        ERR_NO_CONTACT_PERMISSION:
          "No tiene permiso para acceder a este contacto.",
        ERR_NO_SETTING_FOUND: "Ninguna configuraci?n encontrada con este ID.",
        ERR_NO_CONTACT_FOUND: "Ning?n contacto encontrado con este ID.",
        ERR_NO_TICKET_FOUND: "Ning?n t?quete encontrado con este ID.",
        ERR_NO_USER_FOUND: "Ning?n usuario encontrado con este ID.",
        ERR_NO_WAPP_FOUND: "Ning?n WhatsApp encontrado con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear t?quete en la base de datos.",
        ERR_FETCH_WAPP_MSG: "Error al buscar el mensaje en WhatsApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS: "Esta color ya est? en uso, elija otra.",
        ERR_WAPP_GREETING_REQUIRED: "El mensaje de bienvenida es obligatorio cuando hay m?s de una cola.",
        ERR_OUT_OF_HOURS: "?Fuera del Horario de Expediente!"
      }
    }
  }
};

export { messages };
